import { userTeamsSchema } from "@/schema/userTeamsSchema";
import { project_index_get_project } from "@/schema/projectSchema";

const schema = {
  "/uiapi/userteams/getteamslist": userTeamsSchema,
  "/project/index/getproject": project_index_get_project
};


export const getSchema = (key) => {
  return schema?.[key];
};
